import { type Dispatch, type FC, type SetStateAction } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import Select from '__components/Inputs/Select';
import { getDataQAForInput } from 'components/Inputs/helpers';
import type { GenericOption } from 'pages/SmartConnectors/types';
import { useAsync } from 'react-use';
import { FORCE_ALL_RECORDS_SIZE } from 'services/helpers';
import { SMART_CONNECTOR_TYPES } from 'pages/SmartConnectors/constants';
import SmartConnectorService from 'services/SmartConnectorService';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 19px;
  margin-top: 16px;
`;

const RunSmartConnector: FC<{
  smartConnector: GenericOption | null;
  setSmartConnector: Dispatch<SetStateAction<GenericOption>>;
  objectId: string;
}> = ({ smartConnector, setSmartConnector, objectId }) => {
  const { t } = useTranslation();

  const { value: options = [], loading } = useAsync(async () => {
    const res = await SmartConnectorService.getSmartConnectors({
      ordering: 'name',
      page_size: FORCE_ALL_RECORDS_SIZE,
      connector_type: SMART_CONNECTOR_TYPES.bulkaction,
      active: true,
      custom_object: objectId,
    });
    return res.results.map((connector: { id: string; name: string }) => ({
      label: connector.name,
      value: connector.id,
    }));
  }, []);

  return (
    <Wrapper>
      <Select
        fullWidth
        menuInline
        label={t('SmartConnector to Start')}
        options={options}
        isLoading={loading}
        value={smartConnector}
        onChange={setSmartConnector}
        placeholder={t('Choose SmartConnector')}
        {...getDataQAForInput('choose-smart-connector', 'dropdown')}
      />
    </Wrapper>
  );
};

export default RunSmartConnector;
